// SVG ICON : ClockIco
import React from 'react'

type Props = {
  color?: string
}

class LinkArrow extends React.Component<Props> {
  render() {
    const { color } = this.props

    return (
      <svg
        width='12'
        height='12'
        viewBox='0 0 12 12'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M10.5 1.5L1 11'
          stroke={color || '#ffffff'}
          strokeMiterlimit='10'
          strokeLinecap='square'
          strokeLinejoin='bevel'
        />
        <path
          d='M3 1H11V9'
          stroke={color || '#ffffff'}
          strokeMiterlimit='10'
          strokeLinecap='square'
        />
      </svg>
    )
  }
}

export default LinkArrow
